"use client";
import { jsxs as s, jsx as a } from "react/jsx-runtime";
import { Text as c } from "@zapier/design-system";
import "../../hooks/TemplateDetailContext.es.js";
import { useAppDetailsBySlugs as m } from "../../hooks/useAppDetailsBySlugs.es.js";
const _ = "_sidebarSectionTitle_121qc_1", u = "_apps_121qc_6", g = "_app_121qc_6", h = "_appIconContainer_121qc_17", v = "_appIcon_121qc_17", p = {
  sidebarSectionTitle: _,
  apps: u,
  app: g,
  appIconContainer: h,
  appIcon: v
}, f = ({ template: r }) => {
  const n = r.apps;
  if (!n?.length)
    return null;
  const { data: o, isLoading: l } = m({ slugs: n }), d = (e) => {
    var t, i;
    return l ? "" : (i = (t = o?.get(e)) === null || t === void 0 ? void 0 : t.name) !== null && i !== void 0 ? i : e;
  };
  return /* @__PURE__ */ s("section", { children: [
    /* @__PURE__ */ a(c, { type: "ParagraphHeader2", className: p.sidebarSectionTitle, tag: "h2", children: "Apps" }),
    /* @__PURE__ */ a("ul", { className: p.apps, children: n.map((e) => /* @__PURE__ */ s("li", { className: p.app, children: [
      /* @__PURE__ */ a("div", { className: p.appIconContainer, children: /* @__PURE__ */ a("img", { className: p.appIcon, src: `https://zapier.com/generated/${encodeURIComponent(e)}/64`, alt: `${e} icon` }) }),
      /* @__PURE__ */ a(c, { type: "Body3", children: d(e) })
    ] }, e)) })
  ] });
};
export {
  f as AppsSection
};
//# sourceMappingURL=AppsSection.es.js.map
